import { Header } from './Header';
import { HeaderContext } from './HeaderContext';
import { HeaderHeightContext } from './HeaderHeightContext';
import React, { useEffect, useRef, useState } from 'react';
export const HeaderProvider = ({ children, logoUrl, isNavigatorVisible, ...rest }) => {
    const [config, setConfig] = useState({
        isHeaderShown: false,
        isNavigatorVisible,
        isMenuButtonShown: true,
        searchBar: null,
        headerItems: null,
        secondRowItems: null,
        defaults: rest,
        logoUrl,
        ...rest,
    });
    const [resizeListener, setResizeListener] = useState(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const header = useRef(null);
    useEffect(() => {
        if (!header.current && resizeListener !== null) {
            setResizeListener(null);
        }
        else if (header.current && !resizeListener) {
            const ResizeSensor = require('resize-sensor');
            setResizeListener(new ResizeSensor(header.current, () => {
                if (header.current && header.current.offsetHeight !== headerHeight) {
                    setHeaderHeight(header.current.offsetHeight);
                }
            }));
        }
    }, [headerHeight, resizeListener]);
    return (React.createElement(HeaderContext.Provider, { value: [config, setConfig] },
        React.createElement(HeaderHeightContext.Provider, { value: [headerHeight, setHeaderHeight] },
            config.isHeaderShown && React.createElement(Header, { ref: header, config: config }),
            children)));
};
//# sourceMappingURL=HeaderProvider.js.map